export class License {
    id: string;
    reason: string;
    type: string;
    start: string;
    finish: string;
    year: number;
    studentId: string;
    filename: string;
}